import React, { useEffect } from 'react'
import { connect } from 'react-redux'
import { actualizarDatosParaMuiTable } from '../actions/TablaCamionesEnPlayaActions'
import TablaCamionesEnPlayaView from '../components/TablaCamionesEnPlayaView'
import { INTERVALO } from '../../../../../../config/settings'

function TablaCamionesEnPlaya (props) {
  const { actualizarDatosParaMuiTable, filtroInicial, roles } = props

  useEffect(() => {
    const rol = roles.filter(roles => roles === 'EXPORTADOR' || roles === 'CARGADOR' || roles === 'DESARROLLADOR')
    actualizarDatosParaMuiTable(rol, filtroInicial)

    const interval = setInterval(() => {
      actualizarDatosParaMuiTable(rol)
      console.log('Ejecutando actualización de datos...')
    }, INTERVALO)

    return (clearInterval(interval))
  }, [actualizarDatosParaMuiTable, filtroInicial, roles])

  return <TablaCamionesEnPlayaView />
}

const mapStateToProps = state => {
  return {
    roles: state.auth.roles
  }
}

const mapActionsToProps = {
  actualizarDatosParaMuiTable
}

const withRedux = connect(mapStateToProps, mapActionsToProps)
export default withRedux(TablaCamionesEnPlaya)
